import React from 'react';

import { useId } from 'ui/utils';

type Props = {
  name?: string;
  id?: string;
  label: string;
  helpText?: string;
  value: boolean | undefined;
  classNames?: (classes: string[]) => string[];
  onChange: (value: boolean) => void;
  error?: string;
};

function Radio({ name, id, label, helpText, value, classNames = (classes) => classes, onChange, error }: Props) {
  const internalId = useId();
  const inputClasses = ['focus:ring-indigo-500', 'h-4', 'w-4', 'text-indigo-600', 'border'];
  const labelClasses = ['font-medium'];

  if (!name) {
    name = `radio-${internalId}`;
  }

  if (!id) {
    id = `${name}__id`;
  }

  if (error) {
    inputClasses.push('border-red-600');
    labelClasses.push('text-red-600');
  } else {
    inputClasses.push('border-gray-300');
    labelClasses.push('text-gray-700');
  }

  return (
    <div className="relative flex items-start">
      <div className="flex h-5 items-center">
        <input
          id={id}
          name={name}
          value={value ? 'true' : undefined}
          checked={value}
          onChange={onChange}
          type="radio"
          className={classNames(inputClasses.flatMap((cls) => cls.split(' '))).join(' ')}
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className={labelClasses.join(' ')}>
          {label}
        </label>
        {helpText && <p className="text-gray-500">{helpText}</p>}
      </div>
    </div>
  );
}

export default Radio;
